// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"abcf245ba47a15ce89bb","661":"86350d3ed89ce41529e4","838":"53b04a6c5373c399c343"}[chunkId] + ".js";
};